import GroupDetailPage from './GroupDetailPage';
export default GroupDetailPage;
